import React from 'react'
import './About.css'
const About = () => {
  return (
    <div className='about'>About</div>
  )
}

export default About